import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.CompactiveEffort`]: `Compactive Effort`,
      [`${prefix}.OversizeCorrectionData.OversizeVolume`]: `Oversize Volume`,
      [`${prefix}.OversizeCorrectionData.OversizeDensity`]: `Oversize Density`,
      [`${prefix}.OversizeCorrectionData.OversizePropertytoCalculate`]: `Oversize Property to Calculate`,

      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.CompactionBalance`]: 'Compaction Balance',
      [`${prefix}.Equipment.StraightEdge`]: 'Straight Edge',
      [`${prefix}.Equipment.Mould`]: 'Mould',
      [`${prefix}.Equipment.MouldMass`]: 'Mould Mass',
      [`${prefix}.Equipment.MouldVolume`]: 'Mould Volume',
      [`${prefix}.Equipment.UseMouldForAllTestPortions`]: 'Use mould for all test portions',
      [`${prefix}.Equipment.Hammer`]: 'Hammer',
      [`${prefix}.Equipment.HammerOperation`]: 'Hammer Operation',
      [`${prefix}.Equipment.HammerFaceType`]: 'Hammer Face Type',
      [`${prefix}.Equipment.HammerFaceDiameter`]: 'Hammer Face Nominal Diameter',
      [`${prefix}.Equipment.HammerFaceRadius`]: 'Hammer Face Nominal Radius',

      [`${prefix}.TestPortions.Mould`]: 'Mould',
      [`${prefix}.TestPortions.MouldMass`]: 'Mould Mass',
      [`${prefix}.TestPortions.MouldVolume`]: 'Mould Volume',
      [`${prefix}.TestPortions.PortionMass`]: 'Portion Mass',
      [`${prefix}.TestPortions.WaterAddedTargetPercent`]: 'Water Added Target',
      [`${prefix}.TestPortions.WaterAddedTarget`]: 'Water to Add',
      [`${prefix}.TestPortions.PortionMassAfterWaterAdded`]: 'Portion Mass After Addition',
      [`${prefix}.TestPortions.WaterAdded`]: 'Water Added',
      [`${prefix}.TestPortions.WaterAddedPercent`]: 'Actual Water Added',
      [`${prefix}.TestPortions.WetSoilAndMouldMass`]: 'Wet Soil and Mould Mass',
      [`${prefix}.TestPortions.WetSoilMass`]: 'Wet Soil Mass',
      [`${prefix}.TestPortions.WetDensity`]: 'Wet Density',
      [`${prefix}.TestPortions.ConvertedWetDensity`]: 'Converted Wet Density',
      [`${prefix}.TestPortions.ExcludedPoint`]: 'Excluded Point',

      [`${prefix}.FieldResults.FieldDryDensity`]: `Field Dry Density`,
      [`${prefix}.FieldResults.FieldWetDensity`]: `Wet Density`,
      [`${prefix}.FieldResults.FieldMoistureContent`]: `Moisture Content`,
      [`${prefix}.FieldResults.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent`]: 'Moisture Content',
      [`${prefix}.FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldWetDensity`]: 'Wet Density',

      [`${prefix}.Results.PeakConvertedWetDensity`]: 'Peak Converted Wet Density',
      [`${prefix}.Results.PeakMoistureIncrement`]: 'Peak Moisture Increment, Zm',
      [`${prefix}.Results.EnterMoistureCorrection`]: 'Enter moisture correction manually',
      [`${prefix}.Results.MoistureCorrection`]: 'Moisture Correction',
      [`${prefix}.Results.MoistureVariation`]: 'Moisture Variation',
      [`${prefix}.Results.AdjustedPeakConvertedWetDensity`]: 'Adjusted Peak Converted Wet Density',
      [`${prefix}.Results.AdjustedMoistureVariation`]: 'Adjusted Moisture Variation',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Moisture Content',
      [`${prefix}.Results.SoilMoistureLevel`]: 'Soil Moisture Compared to Optimum Moisture',
      [`${prefix}.Results.MoistureRatio`]: 'Moisture Ratio',
      [`${prefix}.Results.HilfDensityRatio`]: 'Hilf Density Ratio',

      [`cwdChart.XAxisMin`]: 'Moisture Increment Start',
      [`cwdChart.XAxisMajorStep`]: 'Moisture Increment Division Size',
      [`cwdChart.YAxisToXAxisStepRatio`]: 'Converted Wet Density to Moisture Increment Ratio',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.TestPortions.WaterAddedTargetPercent`]: '%',
      [`${prefix}.TestPortions.WaterAddedPercent`]: '%',
      [`${prefix}.FieldResults.FieldMoistureContent`]: '%',
      [`${prefix}.FieldResults.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent`]: '%',
      [`${prefix}.Results.PeakMoistureIncrement`]: '%',
      [`${prefix}.Results.MoistureCorrection`]: '%',
      [`${prefix}.Results.MoistureVariation`]: '%',
      [`${prefix}.Results.AdjustedMoistureVariation`]: '%',
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.Results.MoistureRatio`]: '%',
      [`${prefix}.Results.HilfDensityRatio`]: '%',
      [`cwdChart.XAxisMin`]: '%',
      [`cwdChart.XAxisMajorStep`]: '%',
    })
  );

export default getLabelConfig;
